import { getSelectedRowsInCurrentFolder } from '../fileManager/selectors/selectors';
import * as creativeConverterActions from './actions';
import { getNextJob } from './selectors';
import { convertFolder } from './sagasConvertFolder';
import { _select, _take, lm } from '../../listenerMiddleware';
import type { FileManagerRow } from '../fileManager/model';

async function resolveSkipReadyManualProcessing(
  lapi: Parameters<typeof convertFolder>[0],
  rows: FileManagerRow[],
) {
  const readyCount = rows.filter((row) => row.conversionState?.status === 'READY').length;
  if (readyCount === 0) return false;

  lapi.dispatch(
    creativeConverterActions.readyPromptVisibilityChanged({
      visible: true,
      readyCount,
      otherCount: rows.length - readyCount,
    }),
  );

  const action = await _take(lapi, creativeConverterActions.readyPromptResolved);
  return action.payload.result;
}

export function creativeConverterRootListener() {
  lm.takeEvery(creativeConverterActions.convertCreativeButtonClicked, async (_, lapi) => {
    const rows = _select(lapi, getSelectedRowsInCurrentFolder);
    const skipReadyManualProcessing = await resolveSkipReadyManualProcessing(lapi, rows);

    /**
     * CreativeConverterTypes.NODE_ADDED срабатывает для каждой ноды, выбранной
     * для конвертации. Нужно, чтоб все креативы в одной группе выбора
     * обрабатывались вместе, тк у них общий кеш выбранных параметров
     * исправления, который сбрасывается в конце работы
     */

    lapi.dispatch(creativeConverterActions.nodesAdded({ nodes: rows, skipReadyManualProcessing }));

    // eslint-disable-next-line no-constant-condition
    while (true) {
      const job = _select(lapi, getNextJob);
      if (job === undefined) break;
      await convertFolder(lapi, job);
    }

    lapi.dispatch(creativeConverterActions.cacheCleared());
  });
}
